export default __webpack_public_path__ + "static/media/olympic-bake-off-medal-none.51eba22b.svg";